export default {
  GET_PACKAGE_DETAILS_PENDING: 'GET_PACKAGE_DETAILS_PENDING',
  GET_PACKAGE_DETAILS: 'GET_PACKAGE_DETAILS',
  GET_PACKAGE_DETAILS_ERROR: 'GET_PACKAGE_DETAILS_ERROR',
};
